import { useTranslation } from 'react-i18next';

import Checkbox from '@/components/atoms/Checkbox';
import TextField from '@/components/atoms/TextField';

import type {
    OperateWizardAction,
    WizardDestination,
    WizardSource,
} from '../../operateWizardReducer';

import styles from '../../operateModals.module.scss';

interface Props {
    destination: WizardDestination;
    sources: WizardSource[];
    dispatch: (action: OperateWizardAction) => void;
}

/** Which sources feed this destination, each with its own optional count. */
export function DestinationInflows(props: Props) {
    const { destination, sources, dispatch } = props;
    const { t } = useTranslation('fishGroups');

    return (
        <div className={styles.inflowsBlock}>
            <span className={styles.label}>
                {t('actions.operate.destinations.fields.receivesFrom')}
            </span>
            <ul className={styles.inflowsList}>
                {sources.map((source) => {
                    const inflow = destination.receivesFrom.find(
                        (i) => i.sourceFishGroupId === source.fishGroupId
                    );
                    const isChecked = inflow !== undefined;
                    const inputId = `${destination.tempId}-inflow-${source.fishGroupId}`;
                    return (
                        <li key={source.fishGroupId} className={styles.inflowRow}>
                            <Checkbox
                                id={inputId}
                                checked={isChecked}
                                onCheckedChange={() =>
                                    dispatch({
                                        type: 'toggleDestinationInflow',
                                        tempId: destination.tempId,
                                        sourceFishGroupId: source.fishGroupId,
                                    })
                                }
                            />
                            <label className={styles.inflowLabel} htmlFor={inputId}>
                                {source.name}
                            </label>
                            {isChecked && (
                                <TextField
                                    type="number"
                                    min={1}
                                    placeholder={t(
                                        'actions.operate.destinations.fields.inflowCount'
                                    )}
                                    value={inflow.estimatedFishCount}
                                    onChange={(e) =>
                                        dispatch({
                                            type: 'setInflowCount',
                                            tempId: destination.tempId,
                                            sourceFishGroupId: source.fishGroupId,
                                            value: e.target.value,
                                        })
                                    }
                                />
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
